module.exports = __webpack_public_path__ + "img/frame (95).100ca3dc.jpg";